import declare from "dojo/_base/declare";
import Table from "csi/table/Widget";
import PostRequest from "csi/comm/PostRequest";
import { sessionStore } from "csi/state/rootStore";

const RecipeLineItemTable = declare(Table, {

	/**
	 * @override
	 * Refresh Moisture Loss first time we enter to the view
	 */
	onViewStart(dfds) {
		if (!this.bViewed && !this.bPopup && !sessionStore.print) {
			const postRequest = new PostRequest("FormulatedProduct", "RecipeRefreshH2OLoss")
				.addParameter("ParentUrl", this.urlRoot)
				.post({});
			dfds.push(postRequest);
		}

		this.inherited(arguments);
	},
});

export = RecipeLineItemTable;
